var map = {
	"./vtex": [
		8792,
		792
	],
	"./vtex/": [
		8792,
		792
	],
	"./vtex/index": [
		8792,
		792
	],
	"./vtex/index.ts": [
		8792,
		792
	],
	"./vtex/search": [
		835,
		170
	],
	"./vtex/search.ts": [
		835,
		170
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3982;
module.exports = webpackAsyncContext;